import { useContext } from 'react';

import { AlertContext } from '../hoc/AlertContext';

const useAlert = () => useContext(AlertContext);

export default useAlert;